<div class="container">
  <div *ngIf="image" class="container__image-container">
    <app-image-animation style="max-width: 100%;" [imagePath]="image" [altText]="'coffee cup text'"></app-image-animation>
  </div>
  <div *ngIf="formNotSubmitted$ | async" class="container__text">
    <h3  class="container__text__header">{{ header }}</h3>
    <h4 *ngIf="subHeader" class="container__text__sub-header">{{ subHeader }}</h4>
    <ng-content></ng-content>
  </div>
  <app-big-mailchimp-form [type]="type" [allBrands]="allBrands" (submitForm)="onSubmit()"></app-big-mailchimp-form>
</div>
